import React from 'react'
import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import type { AlbumPhoto } from '@paintscout/util/pexels'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'relative',
    cursor: 'pointer',
    borderRadius: theme.borderRadius?.md ?? 4,
    overflow: 'hidden',
    lineHeight: 0,
    '&:hover $overlay': {
      opacity: 1
    },
    '&:hover img': {
      transform: 'scale(1.03)'
    }
  },
  image: {
    width: '100%',
    height: 'auto',
    display: 'block',
    transition: 'transform .25s ease',
    backgroundColor: theme.palette.grey[200]
  },
  overlay: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    padding: theme.spacing(2, 1),
    color: '#fff',
    fontSize: '0.85rem',
    background: 'linear-gradient(to top, rgba(0,0,0,0.65), rgba(0,0,0,0))',
    opacity: 0,
    transition: 'opacity .2s ease',
    pointerEvents: 'none',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}))

export interface PhotoOptionProps {
  photo: AlbumPhoto
}

/**
 * A single selectable tile in the stock-photo masonry. Hotlinks the Pexels-hosted
 * image and shows a subtle photographer credit on hover (Pexels attribution is optional,
 * but crediting the photographer is a nice touch).
 */
function PhotoOption({ photo }: PhotoOptionProps) {
  const classes = useStyles()
  return (
    <div className={classes.root} onClick={photo.onClick} data-testid="stock-photo-option">
      <img className={classes.image} src={photo.src} alt={photo.alt ?? ''} loading={photo.loading ?? 'lazy'} />
      {photo.photographer && <div className={classes.overlay}>{photo.photographer}</div>}
    </div>
  )
}

export default PhotoOption
